module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "max-height": _vm.calcScroll(64 + 2, 56 + 2)
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Журнал операций\n        ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-action-logs-panel', {
    attrs: {
      "topCount": 5
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce424ee2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ActionLogPage.vue
// module id = 998
// module chunks = 1